import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon, XIcon } from 'lucide-react';
export function AudienceSection() {
  const forYou = ['Sos una mujer consciente, sensible, intuitiva', 'Querés abundancia real (recibir y sostener) y autoestima sólida (elegirte y priorizarte)', 'Te sentís estancada, ansiosa o con autosabotaje', 'Querés orden y profundidad, con práctica'];
  const notForYou = ['Buscás solo teoría sin aplicar nada', 'Querés resultados sin mirar tus creencias, emociones o límites'];
  return <section className="w-full bg-cream-50 py-20 md:py-28 px-4" data-id="element-10">
      <div className="max-w-5xl mx-auto" data-id="element-11">
        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="font-heading text-3xl md:text-4xl text-brown-700 text-center mb-12" data-id="element-12">
          Para quién es (y para quién no)
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-8" data-id="element-13">
          {/* For You */}
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="bg-white rounded-2xl p-8 shadow-lg shadow-gold-500/10 border border-gold-100" data-id="element-14">
            <h3 className="font-heading text-2xl text-brown-700 mb-6 flex items-center gap-2" data-id="element-15">
              <span className="w-10 h-10 bg-green-100 rounded-full flex items-center justify-center" data-id="element-16">
                <CheckIcon className="w-5 h-5 text-green-600" data-id="element-17" />
              </span>
              Es para vos si…
            </h3>
            <ul className="space-y-4" data-id="element-18">
              {forYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-19">
                  <CheckIcon className="w-5 h-5 text-green-500 flex-shrink-0 mt-0.5" data-id="element-20" />
                  <span className="text-brown-600" data-id="element-21">{item}</span>
                </li>)}
            </ul>
          </motion.div>

          {/* Not For You */}
          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="bg-cream-100 rounded-2xl p-8 shadow-lg shadow-brown-500/5 border border-cream-300" data-id="element-22">
            <h3 className="font-heading text-2xl text-brown-700 mb-6 flex items-center gap-2" data-id="element-23">
              <span className="w-10 h-10 bg-cream-300 rounded-full flex items-center justify-center" data-id="element-24">
                <XIcon className="w-5 h-5 text-brown-500" data-id="element-25" />
              </span>
              No es para vos si…
            </h3>
            <ul className="space-y-4" data-id="element-26">
              {notForYou.map((item, index) => <li key={index} className="flex items-start gap-3" data-id="element-27">
                  <XIcon className="w-5 h-5 text-brown-400 flex-shrink-0 mt-0.5" data-id="element-28" />
                  <span className="text-brown-500" data-id="element-29">{item}</span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}